import camelCase from 'camelcase';

type Conf = {
  [key: string]: string;
};

const SERVER_TO_UI = {
  googleads: 'adwords',
};

export const normalizeNames = (hash: Conf) => (arg: string) => hash[arg] || arg;

export const normalizeServerName = normalizeNames(SERVER_TO_UI);

export const getUserIntegrationKey = (provider: string) => {
  let userIntegrationKey = null;

  if (provider === 'sizmek_ad_server') {
    userIntegrationKey = 'sizmek';
  } else if (provider === 'adform') {
    userIntegrationKey = 'adform_ad_server';
  } else {
    userIntegrationKey = normalizeServerName(provider);
  }

  return camelCase(userIntegrationKey);
};
